import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import landingHtml from '@/marketing/landing.html?raw';
import { prepareMarketingHtml, makeInternalLinkHandler } from '@/lib/marketing';

export default function Landing() {
  const navigate = useNavigate();
  const html = useMemo(() => prepareMarketingHtml(landingHtml), []);
  const onClick = useMemo(() => makeInternalLinkHandler(navigate), [navigate]);

  useEffect(() => {
    document.title = '18Gimmies — Golf with your group. Score the friendly games.';
  }, []);

  return <div onClick={onClick} dangerouslySetInnerHTML={{ __html: html }} />;
}
